import { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api/client.js';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSubmitting(true);

    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Nepodařilo se odeslat odkaz.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth">
      <h1 className="auth__title">Obnova hesla</h1>
      <p className="auth__subtitle">Zadejte e-mail a pošleme vám odkaz pro změnu hesla.</p>

      {sent ? (
        <div className="auth__info">
          <p>Pokud účet s tímto e-mailem existuje, byl odeslán odkaz pro obnovu hesla.</p>
          <Link to="/login" className="button button--primary">Zpět na přihlášení</Link>
        </div>
      ) : (
        <form className="auth__form" onSubmit={handleSubmit}>
          <label className="auth__label">
            E-mail
            <input
              className="auth__input"
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              autoComplete="email"
              required
            />
          </label>

          {error && <p className="auth__error" role="alert">{error}</p>}

          <button className="button button--primary" type="submit" disabled={submitting}>
            {submitting ? 'Odesílám…' : 'Odeslat odkaz'}
          </button>
        </form>
      )}

      <p className="auth__alt">
        <Link to="/login">Zpět na přihlášení</Link>
      </p>
    </div>
  );
}
